import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Collapse } from 'react-bootstrap';
import { startCase } from 'lodash';
import Fa from 'react-fontawesome';
import DateTimeDisplay from '../../../../components/date-time-display';
import styles from './styles.css';

class NewsItem extends Component {
  constructor() {
    super();
    this.state = {
      open: false,
    };
  }

  createMarkup() {
    const { news: { description } } = this.props;
    const regex = /\!\[video\]\((.*?)\)/ig;

    const video = `
      <div className="embed-responsive embed-responsive-16by9">
        <video width="100%" height="100%" controls>
          <source src="$1" type="video/webm" />
          <code>Your browser does not support the video tag.</code>
        </video>
      </div>
    `;

    const html = (description || '').replace(regex, video);

    return { __html: html };
  }

  renderNewsTags(news) {
    const { types } = news;
    if (types && types.length) {
      return (
        <div>
          {types.map(t => (
            <span key={t}><span className="label label-primary">{startCase(t)}</span> </span>
          ))}
        </div>
      );
    }
    return null;
  }

  render() {
    const { news } = this.props;
    const { open } = this.state;
    const isNew = news.$isNew;
    return (
      <div className={`panel ${isNew ? 'panel-warning' : 'panel-default'}`}>
        <div
          className="panel-heading"
          onClick={() => this.setState({ open: !open })}
          style={{ cursor: 'pointer' }}
        >
          <div className="clearfix">
            <Fa className="pull-right" name={open ? 'times' : 'plus'} />
            <h3 className={`panel-title ${styles.newsTitle}`}>{news.title}</h3>
          </div>
        </div>
        <Collapse in={open}>
          <div className={`panel-body ${styles.newsItem}`}>
            {open && <div dangerouslySetInnerHTML={this.createMarkup()} />}
          </div>
        </Collapse>
        <div className="panel-footer" style={{ borderTop: '1px solid #ddd' }}>
          <div className="clearfix">
            <div className="pull-right">
              <small><em>Published <DateTimeDisplay value={news.announcement_date} format="short" /></em></small>
            </div>
            <div>
              {this.renderNewsTags(news)}
            </div>
          </div>

        </div>
      </div>
    );
  }
}

NewsItem.propTypes = {
  news: PropTypes.shape({
    _id: PropTypes.string.isRequired,
  }).isRequired,
};
NewsItem.defaultProps = {
};
export default NewsItem;
